import {
  SetExhibitorDetail,
  SetExhibitorDetailAfterVoucherRedeem
} from '@core/data-access/models/exhibitor/exhibitor-store.model';
import { CompanyTriple } from '@core/data-access/models/exhibitor/exhibitor.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ExhibitorActions = createActionGroup({
  source: 'Exhibitor',
  events: {
    'Set active exhibitor company triple': (exhibitorCompanyTriple: CompanyTriple) => ({
      exhibitorCompanyTriple
    }),
    'Set exhibitor detail after voucher redeem': props<SetExhibitorDetailAfterVoucherRedeem>(),
    'Set exhibitor detail': props<SetExhibitorDetail>(),
    'Close exhibitor welcome message modal': emptyProps(),
    'Reset reducer': emptyProps()
  }
});
